package oldcomponents

import bootstrap.LinkContainer
import kotlinx.css.minHeight
import kotlinx.css.px
import kotlinx.html.js.onClickFunction
import react.Props
import react.RBuilder
import react.dom.*
import react.fc
import react.router.dom.Link
import styled.styledDiv
import web.cssom.ClassName


external interface HeaderProps : Props {
    var isExtended: Boolean
    var onExtendButtonClick: () -> Unit
    var menuItems: (builder: RBuilder) -> Unit
}

val header = fc<HeaderProps> { props ->
    header("header") {
        nav("navbar fixed-top") {
            div("navbar-holder d-flex align-items-center align-middle justify-content-between") {
                child(logo, props)
                child(menu, props)
            }
        }
    }
}

private val logo = fc<HeaderProps> { props ->
    styledDiv {
        css.classes.add("navbar-header")
        css.minHeight = 71.px

        child(LinkContainer) {
            attrs.to = "/"
            a(classes = "navbar-brand") {
                div("brand-image brand-big") {
                    attrs.jsStyle = kotlinext.js.js {
                        if (!props.isExtended) {
                            display = "none"
                        }
                    }
                    img("logo", "/assets/img/logo-big.png", "logo-big") {}
                }
                div("brand-image brand-small") {
                    attrs.jsStyle = kotlinext.js.js {
                        if (!props.isExtended) {
                            display = "block"
                        }
                    }
                    img("logo", "/assets/img/logo.png", "logo-small") {}
                }
            }
        }

        a(href = "#", classes = "menu-btn${if (props.isExtended) " active" else ""}") {
            attrs.onClickFunction = {
                props.onExtendButtonClick()
                it.preventDefault()
                it.stopPropagation()
            }
            span {  }
            span {  }
            span {  }
        }
    }
}

private val menu = fc<HeaderProps> { props ->
    ul("nav-menu list-unstyled d-flex flex-md-row align-items-md-center pull-right") {
        if (undefined != props.menuItems) {
            props.menuItems(this)
        }
        li("nav-item") {
            Link {
                attrs.to = "/logout"
                attrs.className = ClassName("nav-link")
                    i("la la-sign-out") {}
            }
        }
    }
}